
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { useTranslation } from "react-i18next";
import { toArray as toArray_2, singleton as singleton_1, append as append_1, exists, collect, mapIndexed, tryFind, contains, filter, empty, ofArray, cons, map, isEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { PermissionGroup__ToI18nDescriptionString, ReceiverScope__ToI18nExampleString, BookingScope__ToI18nExampleString, PermissionScopeModule_all, PermissionScope__ToI18nExampleString, PermissionModule_requires, PermissionGrantModule_isGranted, PermissionColumn__ToI18nString, PermissionColumn__get_Key, PermissionGroup__ToI18nString, Permission__ToI18nDescriptionString, PermissionRow__get_Key, PermissionGroup__get_Key, PermissionRow__ToI18nDescriptionString, PermissionRow__ToI18nString, PermissionGrantModule_denied, PermissionColumnModule_crud, PermissionColumn, PermissionModule_byGroup, Permission__get_Row, PermissionModule_column, PermissionColumn_$reflection, Permission_$reflection, PermissionRow_$reflection, PermissionModule_groups, PermissionGroup, PermissionModule_ownScopeMeaning, PermissionGrantModule_withScope, PermissionGrantModule_scope, PermissionGrantModule_withReceiverScope, PermissionGrant, Permission__get_Ladder, Permission__get_Key, ReceiverScope__ToI18nDescriptionString, ReceiverScopeModule_all, ReceiverScope__ToI18nString, BookingScope__ToI18nDescriptionString, BookingScopeModule_all, BookingScope__ToI18nString, PermissionScope, PermissionScope__ToI18nDescriptionString, OwnScopeMeaning__ToI18nString, PermissionScope__ToI18nString, Permission__ToI18nString } from "../../Shared/Roles.js";
import { MultiSelect, Select } from "../../Components/Select.js";
import { empty as empty_1, map as map_2, toArray as toArray_1, singleton, append, delay, toList, iterate } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { unwrap, map as map_1, defaultArg, toArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { curry2, createObj, safeHash, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ReceiverTypeNameModule_all } from "../../Shared/User.js";
import { Storage__get_DisplayName } from "../../Shared/Storage.js";
import { StorageId__get_unwrap } from "../../Shared/Shared.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { isAvailable } from "../../Telematics/Feature.js";
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, list_type, tuple_type, int32_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { InformationTooltip } from "../../Components/InformationTooltip.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { tryFind as tryFind_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { CellContent, ColumnDefinition$1 } from "../../Widgets/Table/Types.js";
import { Table } from "../../Widgets/Table/Table.js";
import { IconChevronRight } from "../../Components/Icon.js";

export function helpArticleUrl(language) {
    if (language.startsWith("de")) {
        return "https://help.inventory-one.com/knowledge-base/wie-lege-ich-eigene-benutzerrollen-an";
    }
    else {
        return "https://help.inventory-one.com/knowledge-base-en/how-do-i-create-custom-user-roles";
    }
}

export function ScopeHint(props) {
    return reactElement("div", {
        "data-test-id": props.TestId,
        className: join(" ", ["text-xs", "text-gray-500", "whitespace-normal", "leading-4"]),
        children: props.Text,
    });
}

export function DependencyHint(props) {
    let arg_1;
    const patternInput = useTranslation();
    const matchValue = props.MissingRequirements;
    if (isEmpty(matchValue)) {
        return defaultOf();
    }
    else {
        const names = join(", ", map((permission) => patternInput[0](Permission__ToI18nString(permission)), matchValue));
        return reactElement("div", {
            "data-test-id": props.TestId,
            className: join(" ", ["text-xs", "text-amber-700", "whitespace-normal", "leading-4"]),
            children: (arg_1 = {
                permissions: names,
            }, patternInput[1].t("settings.roles.dependency_hint", arg_1)),
        });
    }
}

export function receiverTypeLabel(t, receiverType) {
    switch (receiverType.tag) {
        case 1:
            return t("receivers.employee");
        case 2:
            return t("receivers.externalperson");
        case 3:
            return t("receivers.subcontractor");
        case 4:
            return t("receivers.room");
        case 5:
            return t("receivers.project");
        case 6:
            return t("receivers.constructionsite");
        case 7:
            return t("receivers.student");
        case 8:
            return t("receivers.school_class");
        case 9:
            return t("receivers.vehicle");
        case 10:
            return t("receivers.api_receiver");
        default:
            return t("receivers.user");
    }
}

export function ScopeSelect(props) {
    const t = useTranslation()[0];
    const option = (scope) => ({
        label: t(PermissionScope__ToI18nString(scope)),
        value: scope,
    });
    let hint;
    const matchValue = props.Value;
    const matchValue_1 = props.OwnScopeMeaning;
    let matchResult, scope_1;
    if (matchValue.tag === 1) {
        if (matchValue_1 != null) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
            scope_1 = matchValue;
        }
    }
    else {
        matchResult = 1;
        scope_1 = matchValue;
    }
    switch (matchResult) {
        case 0: {
            hint = t(OwnScopeMeaning__ToI18nString(matchValue_1));
            break;
        }
        default:
            hint = t(PermissionScope__ToI18nDescriptionString(scope_1));
    }
    const xs = [createElement(Select, {
        ComponentState: props.ComponentState,
        IsClearable: false,
        NoOptionsMessage: "general.no_options",
        OnChange: (selected) => {
            iterate((selected_1) => {
                props.OnChange(selected_1.value);
            }, toArray(selected));
        },
        Options: map(option, cons(new PermissionScope(0, []), props.Scopes)),
        PlaceholderKey: "settings.roles.scope_placeholder",
        TestId: props.TestId,
        Value: option(props.Value),
    }), createElement(ScopeHint, {
        TestId: concat(props.TestId, ..."-scope-hint"),
        Text: hint,
    })];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function BookingScopeSelect(props) {
    let Text$;
    const t = useTranslation()[0];
    const option = (scope) => ({
        label: t(BookingScope__ToI18nString(scope)),
        value: scope,
    });
    const xs = [createElement(Select, {
        ComponentState: props.ComponentState,
        IsClearable: false,
        NoOptionsMessage: "general.no_options",
        OnChange: (selected) => {
            iterate((selected_1) => {
                props.OnChange(selected_1.value);
            }, toArray(selected));
        },
        Options: map(option, BookingScopeModule_all),
        PlaceholderKey: "settings.roles.scope_placeholder",
        TestId: props.TestId,
        Value: option(props.Value),
    }), createElement(ScopeHint, (Text$ = t(BookingScope__ToI18nDescriptionString(props.Value)), {
        TestId: concat(props.TestId, ..."-scope-hint"),
        Text: Text$,
    }))];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function ReceiverScopeSelect(props) {
    let Text$;
    const t = useTranslation()[0];
    const option = (scope) => ({
        label: t(ReceiverScope__ToI18nString(scope)),
        value: scope,
    });
    const xs = [createElement(Select, {
        ComponentState: props.ComponentState,
        IsClearable: false,
        NoOptionsMessage: "general.no_options",
        OnChange: (selected) => {
            iterate((selected_1) => {
                props.OnChange(selected_1.value);
            }, toArray(selected));
        },
        Options: map(option, ReceiverScopeModule_all),
        PlaceholderKey: "settings.roles.scope_placeholder",
        TestId: props.TestId,
        Value: option(props.Value),
    }), createElement(ScopeHint, (Text$ = t(ReceiverScope__ToI18nDescriptionString(props.Value)), {
        TestId: concat(props.TestId, ..."-scope-hint"),
        Text: Text$,
    }))];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function ReceiverTypeSelect(props) {
    const patternInput = useTranslation();
    const option = (receiverType) => ({
        label: receiverTypeLabel(patternInput[0], receiverType),
        value: receiverType,
    });
    return createElement(MultiSelect, {
        ComponentState: props.ComponentState,
        IsClearable: true,
        NoOptionsMessage: "settings.roles.receiver_types_no_options",
        OnChange: (selected) => {
            props.OnChange(defaultArg(map_1((arg) => map((_arg) => _arg.value, ofArray(arg)), selected), empty()));
        },
        Options: map(option, filter((receiverType_1) => !contains(receiverType_1, props.Selected, {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        }), ReceiverTypeNameModule_all)),
        PlaceholderKey: "settings.roles.receiver_types_placeholder",
        TestId: props.TestId,
        Value: map(option, props.Selected),
    });
}

export function StorageSelect(props) {
    const option_2 = (storageId_1) => {
        let storageId;
        return {
            label: (storageId = storageId_1, defaultArg(map_1(Storage__get_DisplayName, tryFind((storage) => equals(storage.Id, storageId), props.Storages)), StorageId__get_unwrap(storageId))),
            value: storageId_1,
        };
    };
    return createElement(MultiSelect, {
        ComponentState: props.ComponentState,
        IsClearable: true,
        NoOptionsMessage: "settings.roles.storages_no_options",
        OnChange: (selected) => {
            props.OnChange(defaultArg(map_1((arg) => map((_arg) => _arg.value, ofArray(arg)), selected), empty()));
        },
        Options: map((storage_3) => option_2(storage_3.Id), filter((storage_2) => {
            if (!storage_2.IsDeleted) {
                return !contains(storage_2.Id, props.Selected, {
                    Equals: equals,
                    GetHashCode: (x) => (safeHash(x) | 0),
                });
            }
            else {
                return false;
            }
        }, props.Storages)),
        PlaceholderKey: "settings.roles.storages_placeholder",
        TestId: props.TestId,
        Value: map(option_2, props.Selected),
    });
}

export function GrantControl(props) {
    let elems;
    const patternInput = useTranslation();
    const testId = concat("permission-", ...Permission__get_Key(props.Permission));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems = toList(delay(() => {
        let matchValue, matchValue_1, Value;
        return append((matchValue = Permission__get_Ladder(props.Permission), (matchValue_1 = props.Grant, (matchValue.tag === 2) ? ((matchValue_1.tag === 0) ? singleton(Checkbox({
            ComponentState: props.ComponentState,
            IsChecked: equals(matchValue_1.fields[0], new PermissionScope(4, [])),
            Label: patternInput[0]("settings.roles.allowed"),
            OnCheck: (isChecked_2) => {
                props.OnChange(new PermissionGrant(0, [isChecked_2 ? (new PermissionScope(4, [])) : (new PermissionScope(0, []))]));
            },
            TestId: testId,
        })) : singleton(defaultOf())) : ((matchValue.tag === 1) ? ((matchValue_1.tag === 2) ? singleton(createElement(BookingScopeSelect, {
            ComponentState: props.ComponentState,
            OnChange: (arg_1) => {
                props.OnChange(new PermissionGrant(2, [arg_1]));
            },
            TestId: testId,
            Value: matchValue_1.fields[0],
        })) : singleton(defaultOf())) : ((matchValue.tag === 3) ? ((matchValue_1.tag === 3) ? append(singleton(createElement(ReceiverScopeSelect, {
            ComponentState: props.ComponentState,
            OnChange: (scope_4) => {
                props.OnChange(PermissionGrantModule_withReceiverScope(scope_4, props.Grant));
            },
            TestId: testId,
            Value: matchValue_1.fields[0],
        })), delay(() => {
            const matchValue_4 = matchValue_1.fields[0];
            switch (matchValue_4.tag) {
                case 0:
                case 2:
                    return singleton(defaultOf());
                default:
                    return singleton(createElement(ReceiverTypeSelect, {
                        ComponentState: props.ComponentState,
                        OnChange: (receiverTypes_1) => {
                            props.OnChange(new PermissionGrant(3, [matchValue_1.fields[0], receiverTypes_1]));
                        },
                        Selected: matchValue_1.fields[1],
                        TestId: concat(testId, ..."-receiver-types"),
                    }));
            }
        })) : singleton(defaultOf())) : ((matchValue_1.tag === 0) ? append(singleton(createElement(ScopeSelect, (Value = PermissionGrantModule_scope(props.Grant), {
            ComponentState: props.ComponentState,
            OnChange: (scope) => {
                props.OnChange(PermissionGrantModule_withScope(scope, props.Grant));
            },
            OwnScopeMeaning: unwrap(PermissionModule_ownScopeMeaning(props.Permission)),
            Scopes: matchValue.fields[0],
            TestId: testId,
            Value: Value,
        }))), delay(() => {
            const matchValue_3 = props.Grant;
            switch (matchValue_3.tag) {
                case 0:
                case 2:
                case 3:
                    return singleton(defaultOf());
                default:
                    return singleton(createElement(StorageSelect, {
                        ComponentState: props.ComponentState,
                        OnChange: (arg) => {
                            props.OnChange(new PermissionGrant(1, [arg]));
                        },
                        Selected: matchValue_3.fields[0],
                        Storages: props.Storages,
                        TestId: concat(testId, ..."-storages"),
                    }));
            }
        })) : ((matchValue_1.tag === 1) ? append(singleton(createElement(ScopeSelect, (Value = PermissionGrantModule_scope(props.Grant), {
            ComponentState: props.ComponentState,
            OnChange: (scope) => {
                props.OnChange(PermissionGrantModule_withScope(scope, props.Grant));
            },
            OwnScopeMeaning: unwrap(PermissionModule_ownScopeMeaning(props.Permission)),
            Scopes: matchValue.fields[0],
            TestId: testId,
            Value: Value,
        }))), delay(() => {
            const matchValue_3 = props.Grant;
            switch (matchValue_3.tag) {
                case 0:
                case 2:
                case 3:
                    return singleton(defaultOf());
                default:
                    return singleton(createElement(StorageSelect, {
                        ComponentState: props.ComponentState,
                        OnChange: (arg) => {
                            props.OnChange(new PermissionGrant(1, [arg]));
                        },
                        Selected: matchValue_3.fields[0],
                        Storages: props.Storages,
                        TestId: concat(testId, ..."-storages"),
                    }));
            }
        })) : singleton(defaultOf()))))))), delay(() => singleton(createElement(DependencyHint, {
            MissingRequirements: props.MissingRequirements,
            TestId: concat(testId, ..."-dependency-hint"),
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function visibleGroups(accountSettings) {
    return filter((group) => {
        if (!equals(group, new PermissionGroup(20, []))) {
            return true;
        }
        else {
            return isAvailable(accountSettings);
        }
    }, PermissionModule_groups);
}

export class PermissionRowLabel extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Table", "Row", "Single"];
    }
}

export function PermissionRowLabel_$reflection() {
    return union_type("Settings.Roles.PermissionTables.PermissionRowLabel", [], PermissionRowLabel, () => [[], [["Item", PermissionRow_$reflection()]], [["Item", Permission_$reflection()]]]);
}

export class PermissionTableRow extends Record {
    constructor(Order, Label, Cells) {
        super();
        this.Order = (Order | 0);
        this.Label = Label;
        this.Cells = Cells;
    }
}

export function PermissionTableRow_$reflection() {
    return record_type("Settings.Roles.PermissionTables.PermissionTableRow", [], PermissionTableRow, () => [["Order", int32_type], ["Label", PermissionRowLabel_$reflection()], ["Cells", list_type(tuple_type(PermissionColumn_$reflection(), Permission_$reflection()))]]);
}

function rowLabelOf(permission) {
    const matchValue = PermissionModule_column(permission);
    const matchValue_1 = Permission__get_Row(permission);
    if (matchValue.tag === 5) {
        return new PermissionRowLabel(2, [permission]);
    }
    else if (matchValue_1 != null) {
        return new PermissionRowLabel(1, [matchValue_1]);
    }
    else {
        return new PermissionRowLabel(0, []);
    }
}

export function PermissionLabelCell(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "py-1", "whitespace-normal"])], (elems = [reactElement("span", {
        className: join(" ", ["font-semibold"]),
        children: props.Label,
    }), createElement(InformationTooltip, {
        Content: props.Description,
        TestId: props.TestId,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function PermissionTableView(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    const rows = mapIndexed((index, tupledArg) => (new PermissionTableRow(index, tupledArg[0], map((permission_1) => [PermissionModule_column(permission_1), permission_1], tupledArg[1]))), List_groupBy(rowLabelOf, PermissionModule_byGroup(props.Group), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }));
    const cellColumns = collect((row) => map((tuple) => tuple[0], row.Cells), rows);
    const columns = contains(new PermissionColumn(4, []), cellColumns, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    }) ? ofArray([new PermissionColumn(0, []), new PermissionColumn(4, []), new PermissionColumn(5, [])]) : (exists((column) => contains(column, PermissionColumnModule_crud, {
        Equals: equals,
        GetHashCode: (x_2) => (safeHash(x_2) | 0),
    }), cellColumns) ? append_1(PermissionColumnModule_crud, singleton_1(new PermissionColumn(5, []))) : singleton_1(new PermissionColumn(5, [])));
    const grantOf = (permission_2) => defaultArg(tryFind_1(permission_2, props.Permissions), PermissionGrantModule_denied(Permission__get_Ladder(permission_2)));
    const columnDefinition = (id, header, accessor) => (new ColumnDefinition$1(id, "", header, accessor, "none", "text"));
    const columnDefinitions = toArray_1(delay(() => append(singleton(columnDefinition("permission", t("settings.roles.function_column"), (row_1) => {
        let Label, Label_1;
        const matchValue = row_1.Label;
        switch (matchValue.tag) {
            case 1: {
                const permissionRow = matchValue.fields[0];
                return new CellContent(2, [createElement(PermissionLabelCell, (Label = t(PermissionRow__ToI18nString(permissionRow)), {
                    Description: t(PermissionRow__ToI18nDescriptionString(permissionRow)),
                    Label: Label,
                    TestId: `permission-row-${PermissionGroup__get_Key(props.Group)}-${PermissionRow__get_Key(permissionRow)}-tooltip`,
                }))]);
            }
            case 2: {
                const permission_4 = matchValue.fields[0];
                return new CellContent(2, [createElement(PermissionLabelCell, (Label_1 = t(Permission__ToI18nString(permission_4)), {
                    Description: t(Permission__ToI18nDescriptionString(permission_4)),
                    Label: Label_1,
                    TestId: concat("permission-", Permission__get_Key(permission_4), ..."-tooltip"),
                }))]);
            }
            default:
                return new CellContent(0, [t(PermissionGroup__ToI18nString(props.Group))]);
        }
    })), delay(() => map_2((column_2) => columnDefinition(PermissionColumn__get_Key(column_2), t(PermissionColumn__ToI18nString(column_2)), (row_2) => {
        const matchValue_1 = tryFind((tupledArg_1) => equals(tupledArg_1[0], column_2), row_2.Cells);
        if (matchValue_1 != null) {
            const permission_5 = matchValue_1[1];
            return new CellContent(2, [createElement(GrantControl, {
                ComponentState: props.ComponentState,
                Grant: grantOf(permission_5),
                MissingRequirements: filter((requirement) => !PermissionGrantModule_isGranted(grantOf(requirement)), PermissionModule_requires(permission_5)),
                OnChange: curry2(props.OnChange)(permission_5),
                Permission: permission_5,
                Storages: props.Storages,
            })]);
        }
        else {
            return new CellContent(0, [""]);
        }
    }), columns)))));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["[&>div]:!h-auto", "[&>div>div]:!h-auto"])], (elems = [createElement(Table, (TableRows = toArray_2(rows), {
        ColumnDefinitions: columnDefinitions,
        Controls: empty(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["order", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: concat("role-permissions-", ...PermissionGroup__get_Key(props.Group)),
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ScopeLegendEntry(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-0.5"])], (elems = [reactElement("span", {
        className: join(" ", ["font-semibold", "text-sm"]),
        children: props.Label,
    }), reactElement("span", {
        className: join(" ", ["text-sm"]),
        children: props.Description,
    }), reactElement("span", {
        className: join(" ", ["text-xs", "text-gray-500"]),
        children: props.Example,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function PermissionScopeLegend() {
    let elems_6;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const isOpen = patternInput_1[0];
    const block = (title, entries) => {
        let elems;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems = toList(delay(() => append(singleton(reactElement("span", {
            className: join(" ", ["font-bold", "text-sm"]),
            children: title,
        })), delay(() => entries)))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return reactElement("div", createObj(ofArray([["id", "permission-scope-legend"], ["className", join(" ", ["mt-8", "bg-white", "p-4", "flex", "flex-col", "gap-4"])], (elems_6 = toList(delay(() => {
        let elems_3, elems_2, elems_1;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "gap-4"])], (elems_3 = [reactElement("button", createObj(ofArray([["data-test-id", "permission-scope-legend-toggle"], ["type", "button"], ["className", join(" ", ["flex", "items-center", "gap-2", "font-bold", "text-sm", "text-left"])], ["onClick", (_arg) => {
            patternInput_1[1](!isOpen);
        }], (elems_2 = [reactElement("span", createObj(ofArray([["className", join(" ", ["transition-transform", isOpen ? "rotate-90" : "rotate-0"])], (elems_1 = [IconChevronRight(16)], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("span", {
            children: t("settings.roles.legend_title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("a", {
            "data-test-id": "permission-help-link",
            className: join(" ", ["text-sm", "text-primary-link", "underline", "whitespace-nowrap"]),
            href: helpArticleUrl(patternInput[1].language),
            target: "_blank",
            rel: "noopener noreferrer",
            children: t("settings.roles.help_link"),
        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
            let elems_5, elems_4;
            return isOpen ? singleton(reactElement("div", createObj(ofArray([["data-test-id", "permission-scope-legend"], ["className", join(" ", ["flex", "flex-col", "gap-6"])], (elems_5 = [reactElement("span", {
                className: join(" ", ["text-sm"]),
                children: t("settings.roles.legend_intro"),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-1", "lg:grid-cols-3", "gap-6"])], (elems_4 = [block(t("settings.roles.legend_scopes"), toList(delay(() => map_2((scope) => {
                let Label;
                return createElement(ScopeLegendEntry, (Label = t(PermissionScope__ToI18nString(scope)), {
                    Description: t(PermissionScope__ToI18nDescriptionString(scope)),
                    Example: t(PermissionScope__ToI18nExampleString(scope)),
                    Label: Label,
                }));
            }, PermissionScopeModule_all)))), block(t("settings.roles.legend_booking_scopes"), toList(delay(() => map_2((scope_1) => {
                let Label_1;
                return createElement(ScopeLegendEntry, (Label_1 = t(BookingScope__ToI18nString(scope_1)), {
                    Description: t(BookingScope__ToI18nDescriptionString(scope_1)),
                    Example: t(BookingScope__ToI18nExampleString(scope_1)),
                    Label: Label_1,
                }));
            }, BookingScopeModule_all)))), block(t("settings.roles.legend_receiver_scopes"), toList(delay(() => map_2((scope_2) => {
                let Label_2;
                return createElement(ScopeLegendEntry, (Label_2 = t(ReceiverScope__ToI18nString(scope_2)), {
                    Description: t(ReceiverScope__ToI18nDescriptionString(scope_2)),
                    Example: t(ReceiverScope__ToI18nExampleString(scope_2)),
                    Label: Label_2,
                }));
            }, ReceiverScopeModule_all))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty_1();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

export function PermissionGroupSection(props) {
    let elems_2, elems, elems_1;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["id", concat("permission-group-", ...PermissionGroup__get_Key(props.Group))], ["className", join(" ", ["mt-8"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4", "flex", "items-center", "gap-2", "font-bold", "text-sm", "text-black"])], (elems = [reactElement("span", {
        children: t(PermissionGroup__ToI18nString(props.Group)),
    }), createElement(InformationTooltip, {
        Content: t(PermissionGroup__ToI18nDescriptionString(props.Group)),
        TestId: concat("permission-group-", PermissionGroup__get_Key(props.Group), ..."-tooltip"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white"])], (elems_1 = [createElement(PermissionTableView, {
        ComponentState: props.ComponentState,
        Group: props.Group,
        OnChange: props.OnChange,
        Permissions: props.Permissions,
        Storages: props.Storages,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

